import { miniTopics, topicCovers } from "@/mocks/hotData";

export default function TopicSection() {
  const featured = topicCovers[0];
  const side = topicCovers.slice(1);

  return (
    <section id="topics" className="scroll-mt-24 bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
              <i className="ri-article-line"></i>
              瓜点解析
            </span>
            <h2 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              不只是标题，<span className="text-primary-600">一次看透</span>热瓜来龙去脉
            </h2>
          </div>
          <a
            href="#faq"
            className="whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
          >
            追不上？看常见问题
            <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>

        <article className="group mt-8 grid grid-cols-1 gap-0 overflow-hidden rounded-3xl border border-background-200 bg-background-50 md:grid-cols-2">
          <div className="relative h-56 overflow-hidden md:h-auto md:min-h-[340px]">
            <img
              src={featured.img}
              alt={featured.alt}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
              {featured.kicker}
            </span>
          </div>
          <div className="flex flex-col justify-center p-6 md:p-9">
            <div className="flex items-center gap-3 text-xs text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-time-line text-accent-600"></i>
                {featured.time}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-eye-line"></i>
                {featured.reads}
              </span>
            </div>
            <h3 className="mt-3 font-heading text-xl font-black leading-snug text-foreground-950 md:text-2xl">
              {featured.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{featured.summary}</p>
            <div className="mt-6">
              <a
                href="#faq"
                className="inline-flex items-center gap-2 rounded-full bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                完整跟瓜
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </article>

        <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
          {side.map((t) => (
            <article key={t.title} className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200 sm:flex-row">
              <div className="relative h-44 shrink-0 overflow-hidden sm:h-auto sm:w-56">
                <img
                  src={t.img}
                  alt={t.alt}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span className="text-xs font-bold text-accent-700">{t.kicker}</span>
                <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950">{t.title}</h3>
                <p className="mt-2 line-clamp-2 flex-1 text-sm text-foreground-600">{t.summary}</p>
                <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {t.reads}
                  </span>
                  <a href="#faq" className="flex items-center gap-1 font-medium text-primary-700 hover:text-primary-800">
                    阅读全文
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {miniTopics.map((m, i) => (
            <a
              key={m.title}
              href="#faq"
              className="group flex items-start gap-3 rounded-2xl border border-background-200 bg-background-50 p-4 transition-all hover:border-primary-200"
            >
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-xs font-black text-secondary-800">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="min-w-0">
                <span className="text-[11px] text-accent-700">{m.tag}</span>
                <h4 className="mt-1 line-clamp-2 text-sm font-medium text-foreground-800 group-hover:text-primary-700">
                  {m.title}
                </h4>
                <span className="mt-1 block text-[11px] text-foreground-400">{m.reads}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}